// 구독 상태(게이팅용) — React Query. super_admin은 자기 회사 구독이 무의미하므로 비활성.

import { useQuery } from "@tanstack/react-query";

import { billingService } from "@/services/billingService";
import { useAuthStore } from "@/stores/authStore";
import type { BillingStatus } from "@/types/billing";

export function useSubscriptionStatus() {
  const user = useAuthStore((s) => s.user);
  return useQuery<BillingStatus>({
    queryKey: ["billing", "status"],
    queryFn: billingService.getStatus,
    enabled: !!user && user.role !== "super_admin",
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    retry: false,
  });
}

export function formatKRW(amount: number | null | undefined): string {
  if (amount == null) return "-";
  return new Intl.NumberFormat("ko-KR", {
    style: "currency",
    currency: "KRW",
    maximumFractionDigits: 0,
  }).format(amount);
}
